/** Web stubs for presentation result types (no native Superwall on web/SSR). */

export class PresentationResult {
  static fromJson() {
    return new PresentationResult();
  }
}

export class PresentationResultPlacementNotFound extends PresentationResult {}

export class PresentationResultNoAudienceMatch extends PresentationResult {}

export class PresentationResultUserIsSubscribed extends PresentationResult {}

export class PresentationResultPaywallNotAvailable extends PresentationResult {}

export class PresentationResultHoldout extends PresentationResult {}

export class PresentationResultPaywall extends PresentationResult {}
